export default __webpack_public_path__ + "static/media/ed_2.8004b5a0.mp3";